// Dev tools
import ENVIRONMENT from 'config/environment';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import activityReducer from 'services/Account/ActivityLog/reducer';
import accountApiKeysReducer from 'services/Account/APIKeys/reducer';
import apiLogsReducer from 'services/Account/APILogs/reducer';
import docsReducer from 'services/Account/Documents/reducer';
// Account
import invoiceReducer from 'services/Account/Invoice/reducer';
import ipWhitelistReducer from 'services/Account/IpWhitelist/reducer';
import notificationsReducer from 'services/App/Notifications/reducer';
// App
import appReducer from 'services/App/reducer';
import authReducer from 'services/AuthService/authReducer';
import accessReducer from 'services/Colocation/ColocationAccess/reducer';
import crossConnectReducer from 'services/Colocation/CrossConnect/reducer';
// Colocation
import colocationReducer from 'services/Colocation/reducer';
import dasboardReducer from 'services/Dashboard/reducer';
import applicationsReducer from 'services/GameHosting/Application/reducer';
import applicationBuildReducer from 'services/GameHosting/ApplicationBuild/reducer';
import applicationInstancesReducer from 'services/GameHosting/ApplicationInstances/reducer';
import buildProvisioningReducer from 'services/GameHosting/BuildProvisioning/reducer';
import cloudReducer from 'services/GameHosting/Cloud/reducer';
import cloudCredentialsReducer from 'services/GameHosting/CloudCredentials/reducer';
import crashEventReducer from 'services/GameHosting/Crashes/reducer';
// Game hosting
import deploymentEnvironmentReducer from 'services/GameHosting/DeploymentEnv/reducer';
import deploymentProfileReducer from 'services/GameHosting/DeploymentProf/reducer';
import deploymentTemplateReducer from 'services/GameHosting/DeploymentTemp/deploymentTemplateReducer';
import fleetReducer from 'services/GameHosting/Fleet/reducer';
import patchJobReducer from 'services/GameHosting/PatchJob/reducer';
// Host
import hostsReducer from 'services/Hosts/reducer';
import telemetryApplicationInstanceReducer from 'services/Telemetry/ApplicationInstance/reducer';
import telemetryColocationReducer from 'services/Telemetry/Colocation/reducer';
import telemetryCrossConnectReducer from 'services/Telemetry/CrossConnect/reducer';
// Telemetry
import telemetryHostReducer from 'services/Telemetry/Host/reducer';
// Tickets
import ticketReducer from 'services/Tickets/reducer';
import { ReduxActions } from 'types/services/redux';

const reducerList = {
  authReducer,
  appReducer,
  notificationsReducer,
  activityReducer,
  apiLogsReducer,
  deploymentEnvironmentReducer,
  fleetReducer,
  deploymentTemplateReducer,
  deploymentProfileReducer,
  cloudReducer,
  cloudCredentialsReducer,
  ticketReducer,
  applicationsReducer,
  applicationBuildReducer,
  applicationInstancesReducer,
  hostsReducer,
  crashEventReducer,
  docsReducer,
  ipWhitelistReducer,
  accountApiKeysReducer,
  colocationReducer,
  patchJobReducer,
  buildProvisioningReducer,
  invoiceReducer,
  crossConnectReducer,
  accessReducer,
  dasboardReducer,
  telemetryHostReducer,
  telemetryApplicationInstanceReducer,
  telemetryColocationReducer,
  telemetryCrossConnectReducer,
};

const reducers = combineReducers(reducerList);

const rootReducer = (state: $TSFixMe, action: ReduxActions) => {
  if (action.type === 'RESET_APP') {
    return reducers(undefined, action);
  }

  return reducers(state, action);
};

let middleware = [thunk];

if (['local', 'testing', 'development'].includes(ENVIRONMENT)) {
  const logger = createLogger({ collapsed: (_getState, _action, logEntry) => !logEntry?.error });

  // @ts-expect-error ts-migrate(2322) FIXME: Type '(ThunkMiddleware<any, AnyAction, undefined> ... Remove this comment to see the full error message
  middleware = [...middleware, logger];
}

const store = createStore(rootReducer, {}, applyMiddleware(...middleware));

export default store;
